<template>
    
    <div>


    <!-- news and announcements -->
    <div class="row m-0" v-if="newItems && newItems.length">
        <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"/>
        <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12" v-if="newItems && newItems.length">

          <div class="carousel-container">
            <VueSlickCarousel ref="carousel" v-if="newItems && newItems.length" :arrows="false" v-bind="settingsNewItemBanner">
              <div v-for="newItem in newItems" :key="newItem.id">
                <div class="row mr-3 ml-3 bg-white" :style="{'border-radius':'5px'}">
                  <div class="col-12 text-center">
                    <a :href="'/catalogue' + newItem.url" class="product-slide">
                      <img class="product-image mb-3" v-bind:src="'/api/image/get/product/small/' + newItem.image "  :style="{'border-radius':'15px'}"/>
                      <span class="text-dark text-center font-weight-bold">{{newItem.title}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>

            
          </div>

          <!-- <hr class=" mb-4" width="50%" color="#ddd" /> -->
        </div>

        <!-- Custom navigation buttons -->
       

  </div>

  <div class="row mr-4 ml-4 mt-3" v-if="newItems && newItems.length" >
    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12"/>
    <div class="col-lg-4 col-6 text-right mr-lg-2 pr-lg-0 pr-2" v-if="newItems && newItems.length" style="background: linear-gradient(to bottom, white calc(50% - 1px), #f5f5f5a6 calc(50% - 1px), #f5f5f5a6 calc(50% + 1px), white calc(50% + 1px));">
      <span @click="nextSlide"  class="p-1"  style="border-radius: 50%;text-align: center;background-color: #f5f5f5;" >
            <img width="20px" height="20px" class="p-0 m-0" src="@/assets/icons/angle-left.svg" style="cursor:pointer;" />
          </span>
    </div>
    <div class="col-lg-4 col-6 text-left pl-lg-0 pl-2" v-if="newItems && newItems.length" style="background: linear-gradient(to bottom, white calc(50% - 1px), #f5f5f5a6 calc(50% - 1px), #f5f5f5a6 calc(50% + 1px), white calc(50% + 1px));">
          

          <span @click="prevSlide " class="p-1"  style="border-radius: 50%;text-align: center;background-color: #f5f5f5;" > 
        
        <img width="20px" class="p-0 m-0" src="@/assets/icons/angle-right.svg" style="cursor:pointer;" />

          </span>
        </div>
    </div>

  </div>

  
</template>
<script>


import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default ({

    props: {
      newItems:{
          type:Array      
        },

    },

    components: {VueSlickCarousel},

    name: "Banner",

    data() {
        return {
            isArrowLeftActive: true,
      isArrowRightActive: true,

      settingsNewItemBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 750,
          "slidesToShow": 5,
          "slidesToScroll": 1,
          "touchThreshold": 1,
          "arrows": false,

  
  "autoplaySpeed": 4000,
  "cssEase": "linear",


          "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              }
            ]


        }
        }
    },

    methods: {
        prevSlide() {
      this.$refs.carousel.prev();
    },
    nextSlide() {
      this.$refs.carousel.next();
    }
    }
});
</script>
<style scoped>

.product-image {
  width: 100%;       
  height: auto;     
  object-fit: cover; 
  border-radius:5px;
}

.product-image:hover {
  /*border: 1px solid #121212;*/
}

.product-slide {
  color:#c4c4c4;
}

.product-slide:hover {
  /*color: #121212;
  font-weight:bold;*/
}

.product-slide:hover .product-image {
  /*border: 1px solid #121212;*/
 
}


.carousel-container {
  position: relative;
}

.custom-navigation {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
}

.custom-navigation span {
 
    color: black;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 100%;
        
    padding: 7px;
    margin: 7px;
  
    cursor: pointer;

}

</style>